import { jsx as _jsx } from "preact/jsx-runtime";
import styles from './FadeIn.module.scss';
const FadeIn = ({ duration = 300, delay = 0, children, extraCSS, overrideCSS }) => {
    const propsStyle = overrideCSS ? overrideCSS : extraCSS;
    return (_jsx("div", Object.assign({ className: styles.wrapper, style: Object.assign({ animationDuration: duration + 'ms', animationDelay: delay + 'ms' }, propsStyle) }, { children: children }), void 0));
};
export default FadeIn;
